import { useTranslation } from "react-i18next";
import { Image, ImageSourcePropType, Text, View } from "react-native"; // ← import it

type StateDisplayProps = Readonly<{
  descriptionLabel: string;
  imgSource: ImageSourcePropType;
  variant?: "empty" | "error";
}>;

const StateDisplay = ({
  descriptionLabel,
  imgSource,
  variant = "empty",
}: StateDisplayProps) => {
  const { t } = useTranslation();
  return (
    <View className="flex-col justify-center items-center gap-2 p-4 w-full p-6">
      <Image
        source={imgSource}
        style={{ resizeMode: "contain", width: 300, height: 300 }}
      />
      <Text
        className={`mt-2 text-center font-medium text-xl overflow-ellipsis ${variant === "error" ? "text-red-light" : "text-onyx"
          }`}
      >
        {t(descriptionLabel)}
      </Text>
    </View>
  );
};

export default StateDisplay;
